var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-info-body"},[_c('div',[_c('span'),_vm._v(_vm._s(_vm.md_user))]),_c('div',[_c('span'),_vm._v(_vm._s(_vm.md_data))]),_c('div',[_c('span'),_vm._l((_vm.md_label),function(item){return _c('label',{key:item.label_id},[_vm._v(_vm._s(item))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }